import React, { useEffect, useState } from "react";
import { AlertCircle } from "lucide-react";

// Banner sticky-top vermelho que aparece quando o navegador detecta
// offline (window.online/offline events). Auto-some quando volta a
// rede. Z-50 pra ficar acima de quase tudo.

export const BannerOfflineIndicator = () => {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  if (online) return null;
  return (
    <div className="bg-red-600 text-white px-4 py-2 text-xs font-semibold flex items-center gap-2 z-50">
      <AlertCircle size={14} className="flex-shrink-0"/>
      <span>Sem conexão. Algumas funções podem não funcionar até voltar a internet.</span>
    </div>
  );
};
